/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import createTrack from 'services/actions/tracker_actions';

interface ClipboardIconProps {
  value: string;
  action: string;
  className?: string;
  size?: number;
  iconColor?: string;
}

const ClipboardIcon: React.FC<ClipboardIconProps> = ({
  value,
  className = '',
  size = 18,
  iconColor = '#000',
  action,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      await createTrack(action);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Erro ao copiar:', err);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`btn btn-link p-0 ml-2 ${className}`}
      title={copied ? 'Copiado!' : 'Copiar'}
    >
      <i className="material-icons" style={{ fontSize: size, color: iconColor }}>
        {copied ? 'check' : 'content_copy'}
      </i>
    </button>
  );
};

export default ClipboardIcon;
